import React, { memo } from "react";
import { type TooltipRenderProps } from "react-joyride";
import { Box, Button, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useOnboardingGuideContext } from "../context";
import {
  sxActions,
  sxBackButton,
  sxBody,
  sxCloseButton,
  sxContent,
  sxFooter,
  sxHeader,
  sxNextButton,
  sxSkipButton,
  sxTitle,
  sxTooltip,
} from "./styles";

export const CustomTooltip = memo(
  ({
    backProps,
    closeProps,
    index,
    isLastStep,
    primaryProps,
    size,
    skipProps,
    step,
    tooltipProps,
  }: TooltipRenderProps) => {
    const { enableSkipButton } = useOnboardingGuideContext();

    return (
      <Box {...tooltipProps} sx={sxTooltip}>
        {/* Header */}
        <Box sx={sxHeader}>
          <Typography sx={{ fontSize: 12 }}>
            {index + 1} / {size}
          </Typography>
          <IconButton {...closeProps} size="small" sx={sxCloseButton}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Body */}
        <Box sx={sxBody}>
          <Typography variant="subtitle1" sx={sxTitle}>
            {step.title}
          </Typography>
          <Typography component="div" sx={sxContent}>
            {step.content}
          </Typography>
        </Box>

        {/* Footer */}
        <Box sx={sxFooter}>
          {enableSkipButton && !isLastStep && (
            <Button {...skipProps} sx={sxSkipButton}>
              Skip
            </Button>
          )}
          <Box sx={sxActions}>
            {index > 0 && (
              <Button {...backProps} variant="outlined" sx={sxBackButton}>
                Back
              </Button>
            )}
            <Button {...primaryProps} variant="contained" sx={sxNextButton}>
              {isLastStep ? "Done" : "Next"}
            </Button>
          </Box>
        </Box>
      </Box>
    );
  },
);
